module.exports = __webpack_public_path__ + "img/greece.f8fdc226.png";